module.exports = __webpack_public_path__ + "img/banner01.9711dd55.jpg";